<template>
  <div class="page-container">
    <!-- 搜索栏 -->
    <div>
      <div class="page-card__header">
        <el-row>
          <el-col :span="4">
            <span>展商信息（共：{{ aSum }}）</span>
          </el-col>

          <el-col :span="2">
            <div>
              <el-button round size="small" @click="go_to_add"
              >添加展商
              </el-button
              >
            </div>
          </el-col>
          <el-col :span="6" :offset="12">
            <el-input v-model="input">
              <el-button slot="append" icon="el-icon-search" @click="serach"></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%; padding: 0 20px">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="logo" label="logo" width="80">
        <template slot-scope="scope">
          <el-image :src="logoUrl + scope.row.logo" style="width: 30px">
            <div slot="error">
              <i class="el-icon-picture-outline" style="font-size: 30px"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="公司名称"></el-table-column>
      <el-table-column prop="booth" label="展位号" width="80">
      </el-table-column>
      <el-table-column prop="view" label="浏览数" width="80"> </el-table-column>
      <el-table-column prop="praise" label="点赞数" width="80">
      </el-table-column>
      <el-table-column prop="share" label="转发数" width="80">
      </el-table-column>

      <el-table-column prop="invitation" label="预约人数" width="80">
      </el-table-column>
      <el-table-column prop="date_joined" label="加入日期"></el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="handleClick(scope.row)">查看</el-button>
          <el-button type="text" class="action-btn--danger" @click="deleteClick(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {
    name: "",
    data() {
      return {
        tableData: [],
        logoUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/logo/",
        input: '',
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,
      };
    },
    mounted() {
      this.getinfo();
    },
    methods: {
      /** 获取展商列表数据 */
      getinfo() {
        let url = this.baseUrl + "/admin/users/?ordering=-date_joined";
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      /** 分页切换处理 */
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/users/?ordering=-date_joined&page=" + val+"&name__icontains="+this.input;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      /** 跳转到展商详情页 */
      handleClick(row) {
        this.$router.push({
          name: "admin_exhibitorDetails",
          query: {id: row.id},
        });
      },

      /** 删除展商信息 */
      deleteClick(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/admin/users/" + id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getinfo();
          });
        });
      },

      /** 按名称搜索展商 */
      serach() {
        let url = this.baseUrl + "/admin/users/?name__icontains="+this.input;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      /** 跳转到添加展商页面 */
      go_to_add() {
        this.$router.push({name: "admin_addCompany"});
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/companyList.vue